import * as React from 'react';
import clx from 'classnames';
import { Icon, Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin/index';

import './LoaderSpin.scss';
import { OmitProps } from 'antd/lib/transfer/renderListBody';

export interface LoaderSpinProps extends SpinProps {
  full?: boolean;
  transparent?: boolean;
  hasScroll?: boolean;
  children?: React.ReactNode;
}

/**
 * Spinning Loader.
 */
export function LoaderSpin(props: LoaderSpinProps) {
  const { full, transparent, hasScroll, ...otherProps } = props;

  return (
    <div
      className={clx('loader-spin', {
        'full-height': full,
        'no-background': transparent,
        'spin-contain-scroller': hasScroll
      })}
    >
      <Spin
        size="large"
        {...otherProps}
        indicator={<Icon type="loading-3-quarters" spin />}
      />
    </div>
  );
}
